import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap, TweenLite} from "gsap";
import {BasicBitmapCountUp} from "../components/BasicBitmapCountUp";
import {FireInTheHole2} from "../FireInTheHole2";
import {FITH2GameAssets} from "../FITH2GameAssets";
import {FITH2Helper} from "../utils/FITH2Helper";
import {BitmapText} from "pixi.js";
import {FITH2SoundManager} from "../sound/FITH2SoundManager";
import {IWinRatioConfig} from "../configs/FITH2WinConfig";

export class FITH2TotalWinView extends PIXI.Container implements StageLayer {
    private _countUp: BasicBitmapCountUp;

    constructor() {
        super();
        this.name = "TotalWin";
        this.init();
    }

    public show(winRatioConfig: IWinRatioConfig): gsap.core.Timeline {
        const tl = gsap.timeline(),
            totalWinWays: number = FireInTheHole2.model.gameData.waysWonTotalRound,
            winType: string = winRatioConfig.type;
        let toggleType: string = FITH2Helper.getToggleType();
        const waysNumber = new BitmapText(totalWinWays.toString(), {
            fontName: FITH2GameAssets.BITMAP_FONT_WIN_WAYS,
            fontSize: 40,
            tint: 0xffffff
        });
        waysNumber.anchor = new PIXI.Point(0, 1);

        //const effect: Spine = new PIXI.spine.Spine(FireInTheHole2.assetLoader.getSpineAsset("total_win"));
        //effect.position.set(360, 360);
        //effect.name = "totalWin" + toggleType;
        //effect.visible = false;

        const waysText = new PIXI.Sprite(FireInTheHole2.assetLoader.getTextures(`Way${totalWinWays > 1 ? "s" : ""}`)[0]);
        waysText.anchor = new PIXI.Point(0, 0.6);
        waysNumber.letterSpacing = -12;
        const startPos: number = 360 - (waysNumber.width + waysText.width) * 0.5;
        waysNumber.position.set(startPos, 484);
        waysText.position.set(startPos + waysNumber.width, 472);
        this.addChild(waysNumber, waysText, this._countUp);
        const countUpDuration = (winRatioConfig.duration>0.1?(winRatioConfig.duration - 0.2):0);
        tl.add(() => {
            this._countUp.stopAt(0);
            this._countUp.scale.set(0.5, 0.5);
            this._countUp.alpha = 1;
            this.alpha = 0;
            this.visible = true;
        });
        tl.add([
            TweenLite.to(this, 0.1, {alpha: 1}),
            TweenLite.to(this._countUp.scale, 0.1, {x: 1, y: 1, ease: "sine.in"}),
            this._countUp.getCountAnimation(0, FireInTheHole2.model.gameData.accumulatedRoundWin, countUpDuration)
        ]);
        tl.add(() => {
            toggleType = (toggleType.length > 0 ? "_" : "") + toggleType;
            //effect.visible = true;
            //effect.state.setAnimation(0, `win${toggleType}`, false);
            FITH2SoundManager.playSound(`win${winType.charAt(0).toUpperCase() + winType.slice(1)}`);
        }, countUpDuration);
        tl.add([
            () => {
                FireInTheHole2.keypadPlugin.setWin(FireInTheHole2.model.gameData.accumulatedRoundWin, true, FITH2Helper.isWinBelowStake());
            },
            TweenLite.to(this, 0.8, {alpha: 0, delay: 0.6})
        ]);
        tl.add(() => {
            //this.removeChild(effect);
            this.removeChild(waysNumber);
            this.removeChild(waysText);
            //effect.destroy();
            waysNumber.destroy();
            waysText.destroy();
            this.visible = false;
        });
        return tl;
    }

    private init(): void {
        this._countUp = new BasicBitmapCountUp({
            fontName: FITH2GameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 50,
            tint: 0xffffff
        }, 480, new PIXI.Point(0.5, 0.5));
        this._countUp.position.set(360, 360);
        this._countUp.stopAt(0);

        this.visible = false;
        this.addChild(this._countUp);
    }
}